var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6985 20.625L15.4499 1.125C14.5887 -0.375 12.4155 -0.375 11.5485 1.125L0.305098 20.625C-0.560304 22.1196 0.517572 24 2.25212 24H24.7494C26.4771 24 27.5581 22.125 26.6985 20.625ZM12.233 7.28571C12.233 6.57589 12.7999 6 13.4987 6C14.1974 6 14.7643 6.57857 14.7643 7.28571V14.1429C14.7643 14.8527 14.1974 15.4286 13.5461 15.4286C12.8948 15.4286 12.233 14.8554 12.233 14.1429V7.28571ZM13.4987 20.5714C12.5832 20.5714 11.8406 19.8171 11.8406 18.8871C11.8406 17.9571 12.5826 17.2029 13.4987 17.2029C14.4147 17.2029 15.1567 17.9571 15.1567 18.8871C15.1546 19.8161 14.4163 20.5714 13.4987 20.5714Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDanger);
export default __webpack_public_path__ + "static/media/alert-danger.d3e53323b806ed993b1cece31ab6e37e.svg";
export { ForwardRef as ReactComponent };